export default "__VITE_PUBLIC_ASSET__442f3a59__"